'use strict';

const $ = window.jQuery;

export default function() {
    const headings = document.querySelectorAll( '.block-heading > h2' );
    const innerNavItems = document.querySelectorAll( '.inner-nav__link' );
    let activeEl = null;

    const observer = new IntersectionObserver( entries => {
        entries.forEach( entry => {
            if ( entry.isIntersecting ) {
                innerNavItems.forEach( box => box.classList.remove( 'is-active' ) );
                activeEl = Array.from( innerNavItems ).find( ( el ) => el.getAttribute( 'href' ) === '#' + entry.target.id );
                if ( activeEl ) {
                    activeEl.classList.add( 'is-active' );
                }
            }
        } );
    }, {
        threshold: .5,
    } );

    for ( const heading of headings ) {
        observer.observe( heading );
    }
}
